const SHADERTOY_ID = /^[a-z0-9]{6,12}$/i;

export function shadertoyId(value: string): string | undefined {
  const trimmed = value.trim();
  if (!trimmed) return undefined;

  try {
    const url = new URL(trimmed);
    const hostname = url.hostname.toLowerCase();
    if (hostname !== 'shadertoy.com' && hostname !== 'www.shadertoy.com') {
      return undefined;
    }
    const parts = url.pathname.split('/').filter(Boolean);
    if (
      parts.length < 2
      || (parts[0].toLowerCase() !== 'view' && parts[0].toLowerCase() !== 'embed')
      || !SHADERTOY_ID.test(parts[1])
    ) {
      return undefined;
    }
    return parts[1];
  } catch {
    return undefined;
  }
}

export function shadertoyPreviewUrl(shaderId: string): string {
  return `https://www.shadertoy.com/media/shaders/${encodeURIComponent(shaderId)}.jpg`;
}
